import { faLock, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useMutation } from "react-query";
import { register } from "../../../core";
import { useStyles } from "./styles";
import { useHistory, useLocation } from "react-router-dom";
import { ErrorMessage, LoadingButton } from "../..";
import { Link } from "react-router-dom";
import { useTheme } from "react-jss";
import { authenticationContext } from "./Authentication";

const UserInfo = () => {
  const { state } = useLocation();
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const theme = useTheme();
  const styles = useStyles({ theme });
  const { setOtpRequested } = useContext(authenticationContext);

  const { mutate: mutateRegister, isLoading: loading } = useMutation(
    async () => {
      const { data } = await register({ firstname, lastname, password });
      return data;
    },
    {
      onSuccess({ status, message }) {
        if (status) {
          history.push("/login", { message: "ثبت نام با موفقیت انجام شد" });
        } else {
          history.push("/login", { message });
        }
      },
      onError(error) {
        history.push("/login", { message: "خطا" });

        // history.push("/login", { message: "ثبت نام با موفقیت انجام شد" }); //should delete
        setError(error);
      },
    }
  );
  const handleRegister = () => {
    if (!firstname || !lastname || !password || !repeatPassword) {
      setError("لطفا تمام فیلد ها را پر کنید");
    } else if (!firstname) {
      setError(" نام وارد کنید");
    } else if (!lastname) {
      setError(" نام خانوادگی وارد کنید");
    } else if (!password || !repeatPassword) {
      setError("لطفا کلمه عبور را وارد کنید");
    } else if (password !== repeatPassword) {
      setError("کلمه های عبور یکسان نیستند");
    } else {
      mutateRegister();
    }
  };
  const registerByEnter = (e) => {
    if (e.charCode === 13) {
      e.preventDefault();
      handleRegister(e);
    }
  };
  useEffect(() => {
    setError("");
  }, [firstname, lastname, password, repeatPassword]);
  useEffect(() => {
    setOtpRequested(false);
  }, []);

  return (
    <Form className={styles.form}>
      <span className={styles.login100FormTitle}>تکمیل اطلاعات</span>

      <div className={styles.content}>
        <div className={styles.inputsContainer}>
          <div
            className={styles.wrapInput100}
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <Form.Control
              className={styles.input100}
              placeholder="نام"
              type="text"
              onChange={(e) => setFirstname(e.target.value)}
              onKeyPress={registerByEnter}
            />

            <span className={styles.symbolInput}>
              <FontAwesomeIcon icon={faPhone} />
            </span>
          </div>
          <div
            className={styles.wrapInput100}
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <Form.Control
              className={styles.input100}
              placeholder="نام خانوادگی"
              type="text"
              onChange={(e) => setLastname(e.target.value)}
              onKeyPress={registerByEnter}
            />

            <span className={styles.symbolInput}>
              <FontAwesomeIcon icon={faPhone} />
            </span>
          </div>
          <div
            style={{ display: "none" }}
            className={styles.wrapInput100}
            data-validate="Password is required"
          >
            <Form.Control
              placeholder="نام کاربری"
              name="username"
              className={styles.input100}
              type={"text"}
              autoComplete="username"
              value={state?.cellnum ?? "0"}
            />

            <span className={styles.symbolInput}>
              <FontAwesomeIcon icon={faLock} />
            </span>
          </div>
          <div
            className={styles.wrapInput100}
            data-validate="Password is required"
          >
            <Form.Control
              placeholder="کلمه عبور"
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input100}
              type="password"
              autoComplete="new-password"
              onKeyPress={registerByEnter}
            />

            <span className={styles.symbolInput}>
              <FontAwesomeIcon icon={faLock} />
            </span>
          </div>
          <div
            className={styles.wrapInput100}
            data-validate="Password is required"
          >
            <Form.Control
              placeholder="تکرار کلمه عبور"
              onChange={(e) => setRepeatPassword(e.target.value)}
              className={styles.input100}
              type="password"
              autoComplete="new-password"
              onKeyPress={registerByEnter}
            />

            <span className={styles.symbolInput}>
              <FontAwesomeIcon icon={faLock} />
            </span>
          </div>
        </div>
        <div className={styles.footer}>
          <ErrorMessage>{error}</ErrorMessage>

          <div className={styles.containerLogin100FormBtn}>
            <LoadingButton onClick={handleRegister} loading={loading}>
              ثبت نام
            </LoadingButton>
          </div>

          <div className="text-center p-t-12 d-flex justify-content-between">
            <Link to={"forget-password"} className={styles.linkText}>
              فراموشی کلمه عبور
            </Link>
            <Link to={"login"} className={styles.linkText}>
              ورود
            </Link>
          </div>
        </div>
      </div>
    </Form>
  );
};

export { UserInfo };
